<template>
  <div class="provisioning-board">
    <header class="provisioning-board__header">
      <h1>Provisioning runs</h1>
    </header>

    <div v-if="loading" class="provisioning-board__loading">Loading runs…</div>

    <div v-else-if="loadError" class="provisioning-board__error">{{ loadError }}</div>

    <p v-else-if="!runs.length" class="provisioning-board__empty">
      No provisioning runs yet.
    </p>

    <table v-else class="provisioning-board__table">
      <thead>
        <tr>
          <th>Run</th>
          <th>Blueprint</th>
          <th>Reference</th>
          <th>Status</th>
          <th>Step</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in runs"
          :key="row.id"
          class="provisioning-board__row"
          @click="open(row)"
        >
          <td>{{ row.project_title || `#${row.id}` }}</td>
          <td>{{ row.blueprint_key }}</td>
          <td>{{ row.external_ref || '—' }}</td>
          <td>
            <span class="provisioning-board__status" :class="`is-${row.status}`">
              {{ statusLabel(row.status) }}
            </span>
          </td>
          <td>{{ row.current_step_ordinal || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import useApi from '@apexl/icarus-core/src/services/api';
import commonProps from '@apexl/icarus-core/src/components/_properties/common';

// Mounted at `/projects/provisioning-runs` via
// `app\module\projects\Controller\ProjectsDisplayController::index()`.
const props = defineProps({
  ...commonProps,
  apiBase: {
    type: String,
    default: '/api/v1/projects',
  },
});

const api = useApi();
const router = useRouter();

const runs = ref([]);
const loading = ref(true);
const loadError = ref(null);

const RUN_STATUS_LABELS = {
  awaiting_parameters: 'Awaiting parameters',
  pending: 'Pending',
  running: 'Running',
  awaiting_approval: 'Awaiting approval',
  failed: 'Failed',
  completed: 'Completed',
  rolling_back: 'Rolling back',
  rolled_back: 'Rolled back',
  rollback_failed: 'Rollback failed',
};

const statusLabel = (status) => RUN_STATUS_LABELS[status] || status;

function open(row) {
  router.push(`/projects/provisioning-runs/${row.id}`);
}

onMounted(async () => {
  try {
    const data = await api.get(`${props.apiBase}/provisioning-runs`);
    runs.value = data.runs || [];
  } catch (e) {
    loadError.value = e?.response?.data?.error || 'Could not load provisioning runs.';
  } finally {
    loading.value = false;
  }
});
</script>
